import { render, staticRenderFns } from "./before-publish-modal.vue?vue&type=template&id=35adb5f5&"
import script from "./before-publish-modal.vue?vue&type=script&lang=js&"
export * from "./before-publish-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports